import React from "react";

// LactoPilot mark: a navy milk droplet with a green "pilot" arrow inside.
export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 40 40" fill="none" className={className} aria-hidden="true">
    <path
      d="M20 3.5C20 3.5 7.5 16.2 7.5 25a12.5 12.5 0 0 0 25 0C32.5 16.2 20 3.5 20 3.5Z"
      fill="hsl(var(--lp-navy))"
    />
    <path
      d="M13.5 25.5 27 18.5l-5.4 12.6-2.1-5.2-6-0.4Z"
      fill="hsl(var(--lp-green))"
    />
  </svg>
);

export const LogoWordmark = ({ tagline }) => (
  <span className="flex flex-col leading-none">
    <span className="text-lg font-extrabold tracking-tight">
      <span className="text-[hsl(var(--lp-ink))]">Lacto</span>
      <span className="text-[hsl(var(--lp-green))]">Pilot</span>
    </span>
    {tagline && (
      <span className="mt-0.5 text-[9px] font-semibold uppercase tracking-[0.18em] text-[hsl(var(--lp-body))]">
        {tagline}
      </span>
    )}
  </span>
);
